import type { ReactNode } from 'react';
import { VStack } from '@terra/ui-styled-system';

type EntityDrawerSectionsProps = {
  children: ReactNode;
  gap?: string;
};

export const EntityDrawerSections = ({
  children,
  gap = '4',
}: EntityDrawerSectionsProps) => {
  return (
    <VStack gap={gap} alignItems="stretch" w="full">
      {children}
    </VStack>
  );
};
